//Types
export const Types = {
    CREATE_SYSTEM_REQUEST: "CREATE_SYSTEM_REQUEST",
    UPDATE_SYSTEM_REQUEST: "UPDATE_SYSTEM_REQUEST",
    GET_SYSTEM_REQUEST: "GET_SYSTEM_REQUEST",
    GET_SYSTEM_REQUESTS: "GET_SYSTEM_REQUESTS",
    GIVE_SYSTEM_REQUEST: "GIVE_SYSTEM_REQUEST",
    DENY_SYSTEM_REQUEST: "DENY_SYSTEM_REQUEST",
    REMOVE_SYSTEM_REQUEST: "REMOVE_SYSTEM_REQUEST",
    SET_LOADING: "SET_LOADING_SYSTEM_REQUEST",
}

//Reducer
const initialState = {
    systemRequests: null,
    systemRequest: null,
    loading: false,
}

const SystemRequest = (state = initialState, action) => {
    switch(action.type) {
        case Types.CREATE_SYSTEM_REQUEST:
            return {
                ...state,
                systemRequests: action.payload,
                loading: false,
            }

        case Types.UPDATE_SYSTEM_REQUEST:
            return {
                ...state,
                systemRequests: action.payload,
                loading: false,
            }

        case Types.GET_SYSTEM_REQUEST:
            return {
                ...state,
                systemRequest: action.payload,
                loading: false,
            }

        case Types.GET_SYSTEM_REQUESTS:
            return {
                ...state,
                systemRequests: action.payload,
                loading: false
            }

        case Types.GIVE_SYSTEM_REQUEST:
            return {
                ...state,
                ...(action.payload? {systemRequests: action.payload} : {}),
                loading: false,
            }

        case Types.DENY_SYSTEM_REQUEST:
            return {
                ...state,
                systemRequests: action.payload,
                loading: false,
            }

        case Types.REMOVE_SYSTEM_REQUEST:
            return {
                ...state,
                systemRequests: action.payload,
                loading: false,
            }

        case Types.SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state;
    }
}

export default SystemRequest;
